import { Icon, TextLink, Tooltip } from '@teamsnap/snap-ui';
import { DateService } from 'frontend-toolkit';
import * as React from 'react';
import { TransactionRow } from './types';

interface Props {
  transaction: TransactionRow;
  handleRefund: (transaction: TransactionRow) => void;
}

export const TransactionAction = ({ transaction, handleRefund }: Props) => {
  const getEligibilityMessage = () => {
    const today = new Date();
    const txnDate = new Date(transaction.date);
    const isLessThanDays = DateService.compareDates(
      today,
      txnDate,
      3,
      'less_or_equal',
      false
    );

    if (
      transaction.paymentMethodType.toLowerCase() === 'us_bank_account' &&
      isLessThanDays
    ) {
      return 'ACH not eligible for refund for 3 days after submission date.';
    }
    if (transaction.status.toLowerCase() === 'failed') {
      return 'This transaction is not eligible for a refund, as the transaction failed';
    }
    if (
      transaction.status.toLowerCase() === 'refunded' ||
      transaction.refundable === false
    ) {
      return 'This transaction is not eligible for refund, as a refund has already been issued.';
    }
    return '';
  };

  const refundEligibilityMessage = getEligibilityMessage();
  if (refundEligibilityMessage) {
    return (
      <Tooltip align="center" content={refundEligibilityMessage} side="top">
        <Icon data-testid="transactions-table-action--tooltip" name="help" />
      </Tooltip>
    );
  }
  return (
    <TextLink
      data-testid="transactions-table-action--refund"
      href="#"
      onClick={() => handleRefund(transaction)}
    >
      Refund
    </TextLink>
  );
};
